import React from 'react'
import constantes from '../../constantes/constantes'
import clsx from 'clsx'
import Text from '../../shared/textStyleDefault/texto'
import banner_arquitectura from '../../../assets/images/arquitecturaSoftware/Hero-section.svg'
import Banner from '../../shared/banners/banner'
import ContactoBanner from '../../shared/contactBanner/contacto-banner'

const arquitecturasofware = constantes.arquitecturasofware

const Arquitectura = (): any => {
  return (
    <div className='flex flex-col items-center'>
      {/* Banner */}
      <div className='sticky top-0 bg-white'>
        <Banner
          image={banner_arquitectura}
          title="Arquitectura de Software"
          description="Pensamos primero. Construimos después"
        />
      </div>

      {/* Contenido */}
      <div className='sticky w-full bg-white'>
        {arquitecturasofware.map((item, index) => {
          const reversed = index % 2 !== 0

          return (
            <div
              key={item.icono}
              className="w-full max-w-[1250px] mx-auto px-4 py-6 md:py-12"
            >
              <div
                className={clsx(
                  'flex flex-col md:flex-row items-center gap-6',
                  reversed && 'md:flex-row-reverse'
                )}
              >
                {/* Imagen */}
                <div className="w-full md:w-1/2">
                  <img
                    src={item.icono}
                    alt="icono arquitectura"
                    className="w-full h-[168px] md:h-[302px] object-cover rounded-[10px]"
                  />
                </div>

                {/* Texto */}
                <div className="w-full md:w-1/2 text-left">
                  <Text variant="arquitectura-tittle" className="mb-2 md:mb-4">
                    {item.titulo}
                  </Text>
                  <Text as="h5" className="mb-2 md:mb-4">
                    {item.texto}
                  </Text>
                  <Text as="h6" className="font-medium">
                    {item.subtexto}
                  </Text>
                </div>
              </div>
            </div>
          )
        })}

        {/* Banner de contacto */}
        <div className="w-full flex justify-center items-center py-8">
          <ContactoBanner />
        </div>
      </div>
    </div>
  )
}

export default Arquitectura
